import React, { useState } from 'react'
import { Image } from 'lucide-react'

interface ImageWithFallbackProps {
  src: string | null
  alt: string
  className?: string
  fallbackClassName?: string
  fallbackIcon?: React.ReactNode
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  className = "h-20 w-20 rounded-lg object-cover",
  fallbackClassName = "h-20 w-20 rounded-lg bg-gray-200 flex items-center justify-center",
  fallbackIcon = <Image className="h-8 w-8 text-gray-400" />
}) => {
  const [hasError, setHasError] = useState(false)

  if (!src || hasError) {
    return (
      <div className={fallbackClassName}>
        {fallbackIcon}
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
    />
  )
}

export default ImageWithFallback


